/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add course`)
};

const es_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Añadir asignatura`)
};

const de_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Kurs hinzufügen`)
};

const nl_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Vak toevoegen`)
};

const fr_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter un cours`)
};

const it_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi corso`)
};

const pt_br2_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Adicionar disciplina`)
};

const pt_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Adicionar disciplina`)
};

const ja_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 科目を追加`)
};

const zh_gpa_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 添加课程`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_add = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_add(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_add", locale)
	if (locale === "en") return en_gpa_add(inputs)
	if (locale === "es") return es_gpa_add(inputs)
	if (locale === "de") return de_gpa_add(inputs)
	if (locale === "nl") return nl_gpa_add(inputs)
	if (locale === "fr") return fr_gpa_add(inputs)
	if (locale === "it") return it_gpa_add(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_add(inputs)
	if (locale === "pt") return pt_gpa_add(inputs)
	if (locale === "ja") return ja_gpa_add(inputs)
	return zh_gpa_add(inputs)
};